export default "__VITE_ASSET__CFPhPhlt__"